// Constants use for scenes
export const SCENE = {
    MAGIC_SCALE: (1214 / 1500) * 50,
};
